import React, { useEffect, useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Button from "@components/button/button";

import { addDividerOnModal } from "@helpers/helpers";

type PropsTypeContent = {
  onClick?: () => void | undefined;
};

function ContentCapsLockOn({ onClick }: PropsTypeContent) {
  const { formatMessage } = useIntl();

  const modalBody = useRef<HTMLDivElement>(null);
  const hr = useRef<HTMLHRElement>(null);

  useEffect(() => {
    addDividerOnModal(modalBody, hr);
    const close = (event: any) => {
      if (
        event.keyCode === 32 ||
        event.keyCode === 13 ||
        event.keyCode === 27
      ) {
        if (onClick) onClick();
      }
    };
    window.addEventListener("keyup", close);

    return () => window.removeEventListener("keyup", close);
  }, [onClick]);
  return (
    // eslint-disable-next-line
    <>
      <div className='modal-header p-4 pb-0 md:p-6 md:pb-0'>
        <div className='relative text-center'>
          <img
            src='/static/i/svg/ms-target-stop.svg?v=2'
            alt={formatMessage({
              id: "modal-capslock-enabled-title",
            })}
            width='100'
            height='100'
            className='mx-auto mb-4'
          />
          <h3>
            <FormattedMessage id='modal-capslock-enabled-title' />
          </h3>
        </div>
      </div>
      <hr
        className='mx-4 mt-1 border-t-2 border-transparent transition-all md:mx-6'
        ref={hr}
      />
      <div className='modal-body p-4 pt-0 md:p-6 md:pt-0' ref={modalBody}>
        <div className='text-center'>
          <p>
            <FormattedMessage id='modal-capslock-enabled-text' />
          </p>
          <Button
            className='btn-primary outline outline-2 outline-offset-2 outline-state-focus-primary'
            onClick={onClick}
          >
            <FormattedMessage id='continue' />
          </Button>
        </div>
      </div>
    </>
  );
}

export default ContentCapsLockOn;
